import React from 'react'
import { Settings } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminCoverageRules = () => {
  return (
    <GenericTable
      tableName="coverage_rules"
      title="Coverage Rules"
      icon={Settings}
      iconColor="amber"
      searchFields={['rule_code', 'rule_name', 'rule_type', 'rule_category', 'applicable_product']}
      hiddenFields={['rule_id', 'created_at', 'updated_at']}
      primaryKey="rule_id"
      defaultFields={['rule_code', 'rule_name', 'rule_type', 'rule_category', 'applicable_product', 'sum_insured_min', 'sum_insured_max', 'coverage_percentage', 'status']}
      addFields={['rule_code', 'rule_name', 'rule_description', 'rule_type', 'rule_category', 'applicable_product', 'sum_insured_min', 'sum_insured_max', 'coverage_percentage', 'deductible_amount', 'co_payment_percentage']}
      editFields={[
        'rule_name', 'rule_description', 'rule_type', 'rule_category', 'applicable_product',
        'sum_insured_min', 'sum_insured_max', 'coverage_percentage', 'deductible_amount', 'co_payment_percentage',
        'room_rent_limit_per_day', 'room_rent_limit_per_stay', 'pre_existing_condition_waiting_months', 'maternity_waiting_months',
        'min_age_years', 'max_age_years', 'gender_applicable', 'pre_approval_required', 'pre_approval_amount_threshold',
        'out_of_network_coverage', 'out_of_network_coverage_percentage', 'status'
        // Excluded: rule_id, rule_code, created_at, updated_at
      ]}
    />
  )
}

export default AdminCoverageRules
